import React from "react";
import { COLORS } from "../../theme";

// Anel de progresso (SVG + stroke-dasharray) — mesma peça do app mobile (ver
// mobile/src/components/AnelProgresso.js). Mostra "quanto já passou/falta"
// de forma visual; o texto (children) fica centralizado por cima.
export default function AnelProgresso({ progresso = 0, size = 96, espessura = 8, cor = COLORS.primary, corFundo = COLORS.border, children }) {
  const raio = (size - espessura) / 2;
  const circunferencia = 2 * Math.PI * raio;
  const fracao = Math.min(Math.max(progresso, 0), 1);
  const offset = circunferencia * (1 - fracao);

  return (
    <div style={{ width: size, height: size, position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg width={size} height={size} style={{ position: "absolute", inset: 0, transform: "rotate(-90deg)" }}>
        <circle cx={size / 2} cy={size / 2} r={raio} stroke={corFundo} strokeWidth={espessura} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={raio}
          stroke={cor}
          strokeWidth={espessura}
          fill="none"
          strokeDasharray={`${circunferencia} ${circunferencia}`}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset .3s" }}
        />
      </svg>
      <div style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center" }}>{children}</div>
    </div>
  );
}
